import type { SerializedMeterAddon } from '@enmon/commons/lib/tools';
import { Popconfirm, Typography } from 'antd';
import { Button } from 'components';
import { Icon } from 'components/icon';
import { type FC, useCallback } from 'react';
import { useAssignModelToModule } from 'api/hooks/meter-models/useAssignModel';
import { useModelDetailContext } from '../store';

const { Text } = Typography;

interface MeterModelTableActionsProps {
  module: SerializedMeterAddon;
}

export const MeterModelTableActions: FC<MeterModelTableActionsProps> = ({ module }) => {
  const { modelId, model } = useModelDetailContext();

  // Mutations
  const { mutate: assignModelToModule, isLoading: isAssigning } = useAssignModelToModule();

  // Handlers
  const handleAssign = useCallback(() => {
    if (!(model && modelId)) return;

    assignModelToModule({
      model,
      moduleId: module.id,
      assign: false,
    });
  }, [model, modelId, assignModelToModule, module.id]);

  return (
    <Popconfirm
      cancelText="Cancel"
      okText="Confirm"
      title={
        <Text>
          Do you really want to <strong>unassign</strong> this meter module?
        </Text>
      }
      zIndex={99999}
      onConfirm={() => handleAssign()}
    >
      <Button icon={<Icon iconString="unlinkHorizontal" />} loading={isAssigning} type="link">
        Unlink
      </Button>
    </Popconfirm>
  );
};
